import React from 'react';

const WidgetWrapper = ({ children, className = '', ...props }) => {
  return (
    <div className={`widget-wrapper ${className}`} {...props}>
      {children}
    </div>
  );
};

export default WidgetWrapper;

